import React, { useEffect, useState } from "react";
import { vanryLogo } from "utils/constants";
import SocialLinks from "./SocialLinks";

export default function Header() {
  const [scroll, setScroll] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 duration-300 ease-linear ${
        scroll
          ? "py-3 lg:py-[15px] bg-primaryBlack/70 backdrop-blur-[15px]"
          : "py-4 lg:py-[17.61px]"
      }`}
    >
      <div
        className={`navbar-nav max-w-container flex flex-wrap items-center justify-between mx-auto px-3 lg:px-[25px] xl:px-[32px]`}
      >
        <a
          href="/"
          className="relative flex items-center w-[40px] md:w-[46px] space-x-3 rtl:space-x-reverse z-20"
          onClick={() => {
            scrollToTop();
          }}
        >
          {vanryLogo.header}
        </a>
        <div className="relative flex items-center md:order-2 space-x-2 lg:space-x-0 rtl:space-x-reverse z-20">
          <div className="flex flex-row space-x-2 lg:space-x-3 xl:space-x-4 space-y-0">
            {/* <CustomLink
              url=""
              className="primary-gradient px-3 py-2 md:px-4 md:py-[12px] leading-tight"
            >
              Get Started
            </CustomLink> */}

            <SocialLinks />
          </div>
        </div>
      </div>
    </nav>
  );
}
